module.exports = __webpack_public_path__ + "static/media/sensable_18.01a39284.gif";